import { differenceInMonths, formatISO, parseISO, subMonths } from "date-fns";
import { PlaidConnection } from "@common/types/plaidConnection";
import { institutionsWithManuallyProvidedData } from "@common/constants";
import { previousYear } from "../../settings/Billing/constants";

const DATA_FETCH_RANGE_MONTHS = 6;
const EARLIEST_BOOKKEEPING_START = formatISO(new Date(previousYear, 0, 1), {
    representation: "date",
});

export function useManualDataUpload(connection: PlaidConnection) {
    const bookkeepingStartDatesFromEntities = (connection.accounts ?? [])
        .map((acc) => acc.financialAccount?.entity?.bookkeepingStartDate)
        .filter((value): value is string => !!value);

    const earliestBookkeepingStartString =
        bookkeepingStartDatesFromEntities.length > 0
            ? bookkeepingStartDatesFromEntities.reduce(
                  (min, current) => (current < min ? current : min),
                  bookkeepingStartDatesFromEntities[0],
              )
            : EARLIEST_BOOKKEEPING_START;

    const earliestBookkeepingStart = parseISO(earliestBookkeepingStartString);

    const isMissingData =
        connection.institutionId &&
        !connection.historicalDataProvidedManually &&
        institutionsWithManuallyProvidedData.includes(
            connection.institutionId,
        ) &&
        differenceInMonths(connection.createdAt, earliestBookkeepingStart) >
            DATA_FETCH_RANGE_MONTHS;

    return {
        isMissingData: Boolean(isMissingData),
        missingDataStart: earliestBookkeepingStart,
        missingDataEnd: subMonths(
            connection.createdAt,
            DATA_FETCH_RANGE_MONTHS,
        ),
    };
}
